/* What's switched off until the platform can do it (15 Oct 2026). The UI for each is kept, not deleted:
   set a flag to true to bring it back. */

export const FEATURES = {
  /** Combining cohorts: the build panel, the add buttons on tiles, "Add to build" in a cohort's detail panel,
      the skip link to the panel, and "you can combine audiences across them" on the Advertising page. */
  build: false,
  /** Each tile's indicative size, its meter and "fresh counts left today", and the "Largest first" sort. */
  tileSize: false,
  /** Each tile's CPM and the "Lowest CPM first" sort. */
  tilePrice: false,
  /** DNPA's marketplace also lists the data partners' cohorts, tagged Example. */
  crossSource: false,
  /** Experimental (16 Oct 2026): Curation wears ONAM's look (header, footer, side navigation, colours, type).
      Styling only, nothing in Curation changes; false gives back MAP's own look. See onam/skin/. */
  curationSkin: true,
};
